import './lineChart.css';

import { useEffect, useState, useMemo } from 'react';

import { CartesianGrid, Legend, Line, LineChart, Tooltip, XAxis, YAxis, Cell } from "recharts";

export default function LineChartComponent({analyticsTime, filteredCategories}) {
    return(
        <div className="line-chart card">
            <LineChart width={460} height={300} data={filteredCategories[analyticsTime]} className="chart" margin={{ top: 10, right: 10, bottom: 10, left: -18 }}>
                <Line 
                    type="monotone" 
                    dataKey="expense_amount" 
                    stroke="#72BF72"
                    strokeWidth={3}
                    dot={(props) => {
                        const { cx, cy, index } = props;
                        const pointColor = filteredCategories[analyticsTime][index]?.expense_svg_color || "#000";
                        
                        return (
                        <circle 
                            cx={cx} 
                            cy={cy} 
                            r={5} 
                            fill={pointColor} 
                            stroke="none" 
                        />
                        );
                    }}
                    />
                
            
                <CartesianGrid strokeDasharray={"5 5"}/>
                <XAxis dataKey='expense_name' hide/>
                <YAxis />
                <Tooltip />
                
            </LineChart>
        </div>
    )
};